import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CamerallaLayoutModule } from "./cameralla-layout/cameralla-layout.module";
import { DigitalLayoutModule } from "./digital-layout/digital-layout.module";
import { PublicLayoutModule } from "./public-layout/public-layout.module";

@NgModule({
  imports: [
    CommonModule,
    CamerallaLayoutModule,
    DigitalLayoutModule,
    PublicLayoutModule,
  ],
  declarations: [],
  exports: [],
})
export class SharedLayoutModule {}
